import { Component, OnInit, Input, ChangeDetectorRef, AfterViewChecked, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/services/storage.service';
import _ from 'lodash';
import { Storage } from 'src/app/models/storage';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-window-expansion-panel',
  templateUrl: './window-expansion-panel.component.html',
})
export class WindowExpansionPanelComponent implements OnInit, AfterViewChecked, OnDestroy {
  form: FormGroup;
  subscription: Subscription;
  storage: Storage;
  accordionSubscription: Subscription;
  accordion: any;
  @Input() windowKey: number;
  insideLiquidFoilConsumption = 0;
  outsideLiquidFoilConsumption = 0;
  flexConsumption = 0;
  type = null;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    private cdRef: ChangeDetectorRef,
    private accordionService: AccordionService,
  ) { }

  ngOnInit() {
    this.storage = _.cloneDeep(this.storageService.storage);
    this.accordion = this.accordionService.accordion;
    this.type = this.storage.windows[this.windowKey].type;

    this.countConsumption();
    this.storageSubscription();
    this.doAccordionSubscription();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
 }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = _.cloneDeep(data);
      if (this.storage.windows[this.windowKey] === undefined ) {
        return false;
      }
      this.type = this.storage.windows[this.windowKey].type;
      this.countConsumption();
    });
  }

  private doAccordionSubscription() {
    this.accordionSubscription = this.accordionService.accordion$.subscribe(async (data) => {
      this.accordion = _.cloneDeep(data);
    });
  }

  private countConsumption() {
    this.insideLiquidFoilConsumption = 0;
    this.outsideLiquidFoilConsumption = 0;
    this.flexConsumption = 0;

    if (this.type === 'STANDARD') {
      const isSameDepth = this.storage.windows[this.windowKey].standard.isSameDepth;
      const windowDepth = this.storage.windows[this.windowKey].standard.depth;

      _.forEach(this.storage.windows[this.windowKey].standard.inside.edges, edge => {
        const depth = isSameDepth ? windowDepth : edge.depth;

        this.insideLiquidFoilConsumption += 2 * ((10 + edge.width) / 1000) * edge.length / 1000;
        this.flexConsumption += ((edge.width) / 100) * ((depth) / 100) * edge.length / 100;
      });

      _.forEach(this.storage.windows[this.windowKey].standard.outside.edges, edge => {
        const depth = isSameDepth ? windowDepth : edge.depth;

        this.outsideLiquidFoilConsumption += 1 * ((10 + edge.width) / 1000) * edge.length / 1000;
      });

    } else if (this.type === 'NONSTANDARD') {
      _.forEach(this.storage.windows[this.windowKey].nonstandard.inside.edges, edge => {
        this.insideLiquidFoilConsumption += 2 * ((10 + edge.width) / 1000) * edge.length / 1000;
        this.flexConsumption += ((edge.width) / 100) * ((edge.depth) / 100) * edge.length / 100;
      });

      _.forEach(this.storage.windows[this.windowKey].nonstandard.outside.edges, edge => {
        this.outsideLiquidFoilConsumption += 1 * ((10 + edge.width) / 1000) * edge.length / 1000;
      });
    }

    // mnozy wyniki razy ilosc okien
    this.insideLiquidFoilConsumption *= this.storage.windows[this.windowKey].amount;
    this.flexConsumption *= this.storage.windows[this.windowKey].amount;
    this.outsideLiquidFoilConsumption *= this.storage.windows[this.windowKey].amount;

  }

  changeType(type: string) {
    const storage = _.cloneDeep(this.storage);

    storage.windows[this.windowKey].type = type;
    this.storageService.storage = storage;
  }

  handleInputChange($event) {
    const input: HTMLInputElement = $event.target as HTMLInputElement;
    if (input.value === null || input.value === '') {
      return false;
    }
    const val = parseInt(input.value, 10);

    const storage = _.cloneDeep(this.storage);
    storage.windows[this.windowKey].amount = val;

    this.storageService.storage = storage;

    input.value = val.toString();
  }
  changeAccordion(isExpanded: boolean) {
    let windowKey = null;
    if (isExpanded) {
      windowKey = null;
    } else {
      windowKey = this.windowKey;
    }

    const accordion = this.accordion;
    accordion.window = windowKey;

    this.accordionService.accordion = accordion;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.accordionSubscription.unsubscribe();
  }
}
